import React from 'react';
import styled from 'styled-components';
import ConnectTable from './ConnectTable';
import Header from './Header';

const HomeBody = styled.div`
  background-image: var(--home-bg);
`;

const Layout: React.FC = ({ children }) => {
  return (
    <HomeBody className="md:px-4 min-h-full flex flex-col">
      <Header />
      <div className="py-6 px-3 flex-1">{children}</div>
      <div className="pt-8 pb-4">
        <ConnectTable />
      </div>
    </HomeBody>
  );
};

export default Layout;
